import React, { Component, useCallback } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Input, Col, Row, Button, Select, message, InputNumber, DatePicker, Switch, Tooltip } from 'antd'
import * as actions from '@/models/cashCoupon/services'
import dayjs from 'dayjs';
import * as apis from '@/apis'
import {
  QuestionCircleOutlined,
} from '@ant-design/icons';
const { TextArea } = Input;
const { RangePicker } = DatePicker;
@Form.create()
class CashCouponDialogComponent extends Component {
  state = {
    loading: false,
    tenants: [],
    cumulative: false,
  }

  handleSubmit = e => {
    const { coupon = {}, ismodify, submitCallback, onSuccess } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      this.setState({ loading: true })
      if (ismodify !== "modify") {
        actions.addCashCoupon({
          name: values.name,
          fromTime: dayjs(values.fromToTime[0]).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
          toTime: dayjs(values.fromToTime[1]).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
          tenant: values.tenant,
          expiration: values.expiration,
          recharge: values.recharge,
          coupons: values.coupons,
          amount: values.amount,
          memo: values.memo,
          times: values.times,
          cumulative: values.cumulative
        }).then(result => {
          message.success('添加成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      } else {
        actions.updateCashCoupon(coupon._id, {
          name: values.name,
          fromTime: dayjs(values.fromToTime[0]).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
          toTime: dayjs(values.fromToTime[1]).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
          tenant: values.tenant,
          expiration: values.expiration,
          recharge: values.recharge,
          coupons: values.coupons,
          amount: values.amount,
          memo: values.memo,
          times: values.times,
          cumulative: values.cumulative
        }).then(result => {
          message.success('修改成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      }
    });
  }
  queryTeant = async () => {
    this.setState({ loading: true })
    const result = await apis.queryTenants()
    let tenants = []
    result.data.forEach(item => {
      tenants.push({ name: item.short_name, id: item._id })
    });
    this.setState({
      tenants: tenants
    })
  };

  componentDidMount() {
    this.queryTeant()
  }
  render() {
    const { coupon = {}, disabled } = this.props
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    }
    return (
      <div>
        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
          <Form.Item
            label="代金券名称"
            required>
            {getFieldDecorator('name', {
              initialValue: coupon.name,
              rules: [
                {
                  required: true,
                  message: '请输入代金券名称',
                },
              ],
            })(
              <Input disabled={disabled} style={{ width: 300 }} placeholder="请输入代金券名称" />
            )}
          </Form.Item>
          <Form.Item
            label="参与商家">
            {getFieldDecorator('tenant', {
              initialValue: coupon.tenant,
              rules: [
                {
                  required: false,
                  message: '请选择参与商家',
                },
              ],
            })(
              <Select mode="multiple" optionFilterProp="title" placeholder="全部" style={{ width: 300 }} onChange={this.onChange}>
                {
                  this.state.tenants.map(ele => {
                    return <Select.Option key={ele.id} title={ele.name} value={ele.id}>{ele.name}</Select.Option>
                  })
                }
              </Select>
            )}
          </Form.Item>
          <Form.Item
            required
            label="起止时间"
          >
            {getFieldDecorator('fromToTime', {
              initialValue: [dayjs(coupon.fromTime), dayjs(coupon.toTime)]
            })(
              <RangePicker style={{ width: 300 }}
                format="YYYY-MM-DD"
                placeholder="选择起止时间"
              />
            )}
          </Form.Item>
          <Row>
            <Col span={10}>
              <Form.Item labelCol={{ span: 15 }} wrapperCol={{ span: 9 }}
                label="使用有效期(天)"
                required>
                {getFieldDecorator('expiration', {
                  initialValue: coupon.expiration,
                  rules: [
                    {
                      required: true,
                      message: '请输入代金券使用有效期',
                    },
                  ],
                })(
                  <InputNumber disabled={disabled} min={1} precision={0} />
                )}
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                label="充值金额(元)"
                required>
                {getFieldDecorator('recharge', {
                  initialValue: coupon.recharge,
                  rules: [
                    {
                      required: true,
                      message: '请输入充值金额',
                    },
                  ],
                })(
                  <InputNumber disabled={disabled} min={1} precision={0} />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <Form.Item labelCol={{ span: 15 }} wrapperCol={{ span: 9 }}
                label="代金券面值(元)"
                required>
                {getFieldDecorator('coupons', {
                  initialValue: coupon.coupons,
                  rules: [
                    {
                      required: true,
                      message: '请输入代金券面值',
                    },
                  ],
                })(
                  <InputNumber disabled={disabled} min={0.1} precision={1} />
                )}
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                label="代金券数量"
                required>
                {getFieldDecorator('amount', {
                  initialValue: coupon.amount,
                  rules: [
                    {
                      required: true,
                      message: '请输入代金券数量',
                    },
                  ],
                })(
                  <InputNumber disabled={disabled} min={1} precision={0} />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <Form.Item labelCol={{ span: 15 }} wrapperCol={{ span: 9 }}
                label="可领取次数">
                {getFieldDecorator('times', {
                  initialValue: coupon.times ? coupon.times : null,
                  rules: [
                    {
                      required: false,
                      message: '可领取次数',
                    },
                  ],
                })(
                  <InputNumber disabled={disabled} min={1} precision={0} placeholder="无限制" />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                label="超额叠加">
                {getFieldDecorator('cumulative', {
                  initialValue: coupon.cumulative,
                  valuePropName: 'checked',
                  rules: [
                    {
                      required: false,
                      message: '超额叠加',
                    },
                  ],
                })(
                  <Switch disabled={disabled} /*onChange={onCumulativeChange}*/ />
                )} <Tooltip placement="top" title="充值金额除以指定金额的整倍数进行领取"><QuestionCircleOutlined style={{ marginLeft: 5 }} /></Tooltip>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="使用说明">
            {getFieldDecorator('memo', {
              initialValue: coupon.memo,
              rules: [
                {
                  required: false,
                  message: '请输入使用说明',
                },
              ],
            })(
              <TextArea disabled={disabled} style={{ width: 300 }} rows={4} placeholder="请输入使用说明" />
            )}
          </Form.Item>

          <Row>
            <Col style={{ textAlign: "center" }}>
              <Button type="primary" disabled={disabled} htmlType="submit">保存</Button>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

const CashCouponDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={600}
    style={{ top: 30 }}
    visible={isOpen}
    onCancel={hide}>
    <CashCouponDialogComponent onSuccess={hide} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'CASH_COUPON_DIALOG',
})(CashCouponDialog)
